import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const HeroSection: React.FC = () => {
  const { t, dir } = useLanguage();
  const hero = t?.hero || {};
  const isRtl = dir === "rtl";

  const bgUrl =
    (hero as any)?.image || "/images/quilia-1-aA2Fadydc-unsplash.jpg";
  const title =
    (hero as any)?.title ||
    "Global Education Reimagined.\nYour go-to study abroad partner.";
  const subtitle =
    (hero as any)?.subtitle ||
    "Fuel your education with the right opportunity: personalized journeys customized for every student's needs with one goal: building the right future.";
  const cta = (hero as any)?.cta || "Get in touch";
  const sideGradient = isRtl
    ? "linear-gradient(270deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.54) 42%, rgba(0,0,0,0.12) 100%)"
    : "linear-gradient(90deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.54) 42%, rgba(0,0,0,0.12) 100%)";

  return (
    <section
      className="relative min-h-screen overflow-hidden text-white"
      aria-label="Hero"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${bgUrl}')`,
        }}
      />

      <div className="absolute inset-0 bg-second-color/20 mix-blend-multiply" />
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute inset-0" style={{ background: sideGradient }} />

      <div
        className={`site-container relative z-10 flex min-h-screen items-end pb-16 pt-32 md:pb-20 lg:pb-20 ${
          isRtl ? "justify-end text-right" : "justify-start text-left"
        }`}
      >
        <div
          className={`inline-flex w-full max-w-[759px] flex-col justify-start gap-6 ${
            isRtl ? "items-end" : "items-start"
          }`}
        >
          <div
            className={`flex w-full flex-col justify-start gap-3 ${
              isRtl ? "items-end" : "items-start"
            }`}
          >
            <h1 className="hero-title w-full max-w-[820px] whitespace-pre-line text-white">
              {title}
            </h1>
            <p className="hero-subtitle w-full max-w-[609px] text-white">
              {subtitle}
            </p>
          </div>

          <Link
            to="/contact"
            data-property-1="prim"
            className="inline-flex min-h-12 w-full items-center justify-center gap-2.5 bg-second-color px-6 py-2 text-center font-sans text-base font-semibold leading-6 text-main-color transition-colors hover:bg-second-color/90 focus:outline-none focus:ring-2 focus:ring-main-color focus:ring-offset-2 focus:ring-offset-black sm:w-fit sm:min-w-[180px]"
          >
            {cta}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
